import React from 'react';
import BaseDropdown from "app/main/shared-components/base-dropdown/BaseDropdown";
import {DropdownItemTypes} from "app/types/DropdownTypes";
import {logoutUser} from "app/auth/store/user.slice";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "app/store";
import {ROLES} from "app/constants/roles";
import useAuthority from "app/hooks/useAuthority";
import { t } from 'i18next';

const UserMenu = () => {
  const dispatch = useDispatch();
  const stateUser = useSelector((state: AppState) => state.auth.user);
  const {hasUserAnyAuthority} = useAuthority();

  const items: DropdownItemTypes[] = [];

  if (hasUserAnyAuthority([ROLES.ROLE_AGENT])) {
    items.push({
      icon: "settings",
      title: t("app.common.auth.Settings", "Settings"),
      onClick: () => {
        window.location.href = "/settings";
      },
    });
  }

  items.push({
  icon: "exit_to_app",
  title: t("app.common.auth.logout", "Logout"),
  onClick: () => {
    dispatch(logoutUser());
  },
});

 // @ts-ignore
  return stateUser && <BaseDropdown color={'primary'} icon='account_circle_outlined' title={stateUser.fullName} items={items}/>
};

export default UserMenu;